'use client';

import type { ComponentPropsWithoutRef } from 'react';
import { PropertyCard } from '@zillow/constellation-10';
import { cx } from '@/styled-system/css';
import { NO_PHOTO_ALT_TEXT } from '@/src/components/features/property/lib/getHaloPhotos';
import * as styles from './propertyPhotoFallback.styles';

type PropertyPhotoFallbackProps = ComponentPropsWithoutRef<'span'> & {
  altText?: string;
  iconSize?: 'xl' | 'xxl';
};

export function PropertyPhotoFallback({
  altText = NO_PHOTO_ALT_TEXT,
  className,
  iconSize = 'xxl',
  ...rest
}: PropertyPhotoFallbackProps) {
  const size = iconSize === 'xl' ? 'icon.xl' : 'icon.xxl';

  return (
    <span className={cx(styles.fallbackSurface, className)} {...rest}>
      <PropertyCard.PhotoFallback
        role="img"
        altText={altText}
        css={{
          blockSize: size,
          inlineSize: size,
        }}
      />
    </span>
  );
}
